import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import { BACK_BUTTON_LABEL, SUBMITTING_LABEL } from './feedbackCopy';
const FeedbackFooter = ({
  onBack,
  submitLabel,
  submitColor,
  isSubmitDisabled,
  isSubmitting
}) => /*#__PURE__*/React.createElement("div", {
  className: "t-feedback-footer"
}, /*#__PURE__*/React.createElement(Button, {
  type: "button",
  color: "secondary",
  outline: true,
  onClick: onBack,
  disabled: isSubmitting
}, BACK_BUTTON_LABEL), /*#__PURE__*/React.createElement(Button, {
  type: "submit",
  color: submitColor,
  disabled: isSubmitDisabled
}, isSubmitting ? SUBMITTING_LABEL : submitLabel));
FeedbackFooter.propTypes = {
  onBack: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
  submitColor: PropTypes.string.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired
};
export default FeedbackFooter;